import ProfileLayout from "../../layouts/ProfileLayout";
import React, { useState } from "react";
import { deletAccount } from "../../apiHandles/user_progress"
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

const Settings = () => {

  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [darkMode, setDarkMode] = useState(() => {
    // Προσπαθούμε να διαβάσουμε από το localStorage αν υπάρχει
    const stored = localStorage.getItem("darkMode");
    return stored ? JSON.parse(stored) : false;
  });

  const [language, setLanguage] = useState(() => {
    // Προσπαθούμε να διαβάσουμε από το localStorage αν υπάρχει
    const stored = localStorage.getItem("language");
    return stored || "greek";
  });

  const [soundEnabled, setSoundEnabled] = useState(() => {
    // Προσπαθούμε να διαβάσουμε από το localStorage αν υπάρχει
    const stored = localStorage.getItem("soundEnabled");
    return stored ? JSON.parse(stored) : true;
  });

  const handleLanguageChange = (selectedLanguage) => {
    setLanguage(selectedLanguage);
    localStorage.setItem("language", selectedLanguage);
  };

  const toggleSound = () => {
    setSoundEnabled((prev) => {
      const newValue = !prev;
      localStorage.setItem("soundEnabled", JSON.stringify(newValue));
      return newValue;
    });
  };

  const handleDeleteAccount = async () => {
    const deleted = await deletAccount();
    if (deleted) {
      navigate("/login");
    }
    setShowDeleteModal(false);
  };

  return (
    <ProfileLayout>
      <Container
        fluid
        style={{
          background: "#0f172a",
          minHeight: "100vh",
          paddingTop: "2rem",
          paddingBottom: "2rem",
          transition: "background 0.3s"
        }}
      >
        <Card
          className="shadow"
          style={{
            background: "rgba(51, 65, 85, 0.5)",
            color: "#e2e8f0",
            maxWidth: "500px",
            margin: "0 auto",
            marginBottom: "18%",
            borderRadius: "24px",
            padding: "32px",
            border: "none",
            //backdropFilter: "blur(16px)",
            //transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
          }}
        >
          <CardHeader className="border-0" style={{ paddingBottom: "0", background: "none" }}>
            <div style={{ textAlign: "center", marginBottom: "32px" }}>
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "16px",
                  background: darkMode
                    ? "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
                    : "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px",

                }}
              >
                <i
                  className="fa-solid fa-gear"
                  style={{
                    fontSize: "24px",
                    color: "#ffffff",
                    animation: "spin 8s linear infinite"
                  }}
                ></i>
              </div>
              <h3
                style={{
                  color: "#f1f5f9",
                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                  fontWeight: 700,
                  fontSize: "28px",
                  letterSpacing: "-0.025em",
                  margin: 0,
                  transition: "color 0.3s"
                }}
              >
                Settings
              </h3>
              <p
                style={{
                  color: darkMode ? "#94a3b8" : "#64748b",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "16px",
                  fontWeight: 400,
                  margin: "8px 0 0",
                  opacity: 0.8
                }}
              >
                Customize your experience
              </p>
            </div>
          </CardHeader>

          <CardBody style={{ padding: "0" }}>


            {/* Language Setting */}
            <div
              style={{
                background: darkMode ? "rgba(30, 41, 59, 0.5)" : "rgba(248, 250, 252, 0.8)",
                borderRadius: "16px",
                padding: "20px",
                border: darkMode
                  ? "1px solid rgba(148, 163, 184, 0.1)"
                  : "1px solid rgba(203, 213, 225, 0.3)",
                transition: "all 0.3s ease"
              }}
            >
              <div
                style={{
                  marginBottom: "16px"
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    color: darkMode ? "#f1f5f9" : "#0f172a",
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 600,
                    marginBottom: "4px",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px"
                  }}
                >
                  <i
                    className="fa-solid fa-language"
                    style={{
                      color: darkMode ? "#06b6d4" : "#0891b2",
                      fontSize: "20px"
                    }}
                  ></i>
                  Language / Γλώσσα
                </div>
                <p
                  style={{
                    fontSize: "14px",
                    color: darkMode ? "#94a3b8" : "#64748b",
                    margin: 0,
                    fontFamily: "Inter, sans-serif"
                  }}
                >
                  Choose your preferred language
                </p>
              </div>

              <div style={{ display: "flex", gap: "12px" }}>
                <button
                  style={{
                    flex: 1,
                    padding: "12px 20px",
                    borderRadius: "12px",
                    border: "none",
                    fontSize: "15px",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                    cursor: "pointer",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    background: language === "greek"
                      ? "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
                      : darkMode
                        ? "rgba(51, 65, 85, 0.8)"
                        : "rgba(241, 245, 249, 0.8)",
                    color: language === "greek"
                      ? "#ffffff"
                      : darkMode ? "#e2e8f0" : "#475569",

                    transform: "translateY(0)"
                  }}
                  onMouseEnter={(e) => {
                    if (language !== "greek") {
                      e.target.style.transform = "translateY(-2px)";

                    }
                  }}
                  onMouseLeave={(e) => {
                    if (language !== "greek") {
                      e.target.style.transform = "translateY(0)";

                    }
                  }}
                  onClick={() => handleLanguageChange("greek")}
                >
                  🇬🇷 Ελληνικά
                </button>

                <button
                  style={{
                    flex: 1,
                    padding: "12px 20px",
                    borderRadius: "12px",
                    border: "none",
                    fontSize: "15px",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                    cursor: "pointer",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    background: language === "english"
                      ? "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
                      : darkMode
                        ? "rgba(51, 65, 85, 0.8)"
                        : "rgba(241, 245, 249, 0.8)",
                    color: language === "english"
                      ? "#ffffff"
                      : darkMode ? "#e2e8f0" : "#475569",

                    transform: "translateY(0)"
                  }}
                  onMouseEnter={(e) => {
                    if (language !== "english") {
                      e.target.style.transform = "translateY(-2px)";

                    }
                  }}
                  onMouseLeave={(e) => {
                    if (language !== "english") {
                      e.target.style.transform = "translateY(0)";

                    }
                  }}
                  onClick={() => handleLanguageChange("english")}
                >
                  🇺🇸 English
                </button>
              </div>
            </div>

            <br></br>

            {/* Sound Setting */}
            <div
              style={{
                background: darkMode ? "rgba(30, 41, 59, 0.5)" : "rgba(248, 250, 252, 0.8)",
                borderRadius: "16px",
                padding: "20px",
                border: darkMode
                  ? "1px solid rgba(148, 163, 184, 0.1)"
                  : "1px solid rgba(203, 213, 225, 0.3)",
                transition: "all 0.3s ease"
              }}
            >
              <div
                style={{
                  marginBottom: "16px"
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    color: darkMode ? "#f1f5f9" : "#0f172a",
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 600,
                    marginBottom: "4px",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px"
                  }}
                >
                  <i
                    className={soundEnabled ? "fa-solid fa-volume-high" : "fa-solid fa-volume-xmark"}
                    style={{
                      color: soundEnabled
                        ? (darkMode ? "#10b981" : "#059669")
                        : (darkMode ? "#f59e0b" : "#d97706"),
                      fontSize: "20px",
                      transition: "all 0.3s ease"
                    }}
                  ></i>
                  Sound Effects / Ήχοι
                </div>
                <p
                  style={{
                    fontSize: "14px",
                    color: darkMode ? "#94a3b8" : "#64748b",
                    margin: 0,
                    fontFamily: "Inter, sans-serif"
                  }}
                >
                  Enable or disable sound effects
                </p>
              </div>

              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <button
                  onClick={toggleSound}
                  style={{
                    position: "relative",
                    width: "80px",
                    height: "44px",
                    borderRadius: "22px",
                    border: "none",
                    cursor: "pointer",
                    background: soundEnabled
                      ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                      : "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)",
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    boxShadow: soundEnabled
                      ? "0 8px 32px rgba(16, 185, 129, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)"
                      : "0 8px 32px rgba(107, 114, 128, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05)",
                    overflow: "hidden"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "scale(1.05)";
                    e.target.style.boxShadow = soundEnabled
                      ? "0 12px 40px rgba(16, 185, 129, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.15)"
                      : "0 12px 40px rgba(107, 114, 128, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "scale(1)";
                    e.target.style.boxShadow = soundEnabled
                      ? "0 8px 32px rgba(16, 185, 129, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)"
                      : "0 8px 32px rgba(107, 114, 128, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05)";
                  }}
                >
                  {/* Animated Background Waves */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: soundEnabled
                        ? "radial-gradient(circle at 30% 50%, rgba(255,255,255,0.15) 0%, transparent 50%)"
                        : "radial-gradient(circle at 70% 50%, rgba(255,255,255,0.08) 0%, transparent 50%)",
                      transition: "all 0.4s ease",
                      borderRadius: "22px"
                    }}
                  />

                  {/* Toggle Knob */}
                  <div
                    style={{
                      position: "absolute",
                      top: "4px",
                      left: soundEnabled ? "40px" : "4px",
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2
                    }}
                  >
                    <i
                      className={soundEnabled ? "fa-solid fa-volume-high" : "fa-solid fa-volume-xmark"}
                      style={{
                        fontSize: "14px",
                        color: soundEnabled ? "#059669" : "#6b7280",
                        transition: "all 0.3s ease"
                      }}
                    />
                  </div>

                  {/* Sound Wave Animation (when enabled) */}
                  {soundEnabled && (
                    <>
                      <div
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          display: "flex",
                          gap: "2px",
                          alignItems: "center"
                        }}
                      >
                        <div
                          style={{
                            width: "2px",
                            height: "8px",
                            background: "rgba(255, 255, 255, 0.6)",
                            borderRadius: "1px",
                            animation: "soundWave1 1.5s infinite ease-in-out"
                          }}
                        />
                        <div
                          style={{
                            width: "2px",
                            height: "12px",
                            background: "rgba(255, 255, 255, 0.6)",
                            borderRadius: "1px",
                            animation: "soundWave2 1.5s infinite ease-in-out 0.2s"
                          }}
                        />
                        <div
                          style={{
                            width: "2px",
                            height: "6px",
                            background: "rgba(255, 255, 255, 0.6)",
                            borderRadius: "1px",
                            animation: "soundWave3 1.5s infinite ease-in-out 0.4s"
                          }}
                        />
                      </div>
                    </>
                  )}
                </button>
              </div>

              {/* Status Text */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "12px"
                }}
              >
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: soundEnabled
                      ? (darkMode ? "#10b981" : "#059669")
                      : (darkMode ? "#9ca3af" : "#6b7280"),
                    fontFamily: "Inter, sans-serif",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    transition: "color 0.3s ease"
                  }}
                >
                  {soundEnabled ? "ENABLED" : "DISABLED"}
                </span>
              </div>
            </div>

            <br></br>

            {/* Delete Account Section */}
            <div
              style={{
                background: darkMode ? "rgba(30, 41, 59, 0.5)" : "rgba(248, 250, 252, 0.8)",
                borderRadius: "16px",
                padding: "20px",
                border: darkMode
                  ? "1px solid rgba(148, 163, 184, 0.1)"
                  : "1px solid rgba(203, 213, 225, 0.3)",
                transition: "all 0.3s ease",
                textAlign: "center"
              }}
            >
              <div
                style={{
                  marginBottom: "16px"
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    color: darkMode ? "#f1f5f9" : "#0f172a",
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 600,
                    marginBottom: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px"
                  }}
                >
                  <i
                    className="fa-solid fa-trash"
                    style={{
                      color: "#ef4444",
                      fontSize: "20px"
                    }}
                  ></i>
                  Διαγραφή λογαριασμού
                </div>
                <p
                  style={{
                    fontSize: "14px",
                    color: darkMode ? "#94a3b8" : "#64748b",
                    margin: 0,
                    fontFamily: "Inter, sans-serif"
                  }}
                >
                  This action cannot be undone
                </p>
              </div>

              <Button
                style={{
                  background: "#ef4444",
                  border: "none",
                  borderRadius: "12px",
                  padding: "12px 24px",
                  fontWeight: 600,
                  fontFamily: "Inter, sans-serif",
                  fontSize: "15px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(239, 68, 68, 0.3)"
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#dc2626";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 8px 24px rgba(239, 68, 68, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "#ef4444";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 4px 12px rgba(239, 68, 68, 0.3)";
                }}
                onClick={() => setShowDeleteModal(true)}
              >
                Delete account
              </Button>
            </div>

          </CardBody>
        </Card>

        {/* Delete Confirmation Modal */}
        <Modal
          isOpen={showDeleteModal}
          toggle={() => setShowDeleteModal(false)}
          centered
          style={{
            fontFamily: "Inter, sans-serif"
          }}
        >
          <ModalHeader
            toggle={() => setShowDeleteModal(false)}
            style={{
              background: darkMode ? "#1e293b" : "#ffffff",
              color: darkMode ? "#f1f5f9" : "#1e293b",
              borderBottom: darkMode ? "1px solid rgba(148, 163, 184, 0.1)" : "1px solid #e2e8f0"
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <i className="fa-solid fa-triangle-exclamation" style={{ color: "#ef4444", fontSize: "20px" }}></i>
              Confirm Account Deletion
            </div>
          </ModalHeader>
          <ModalBody
            style={{
              background: darkMode ? "#1e293b" : "#ffffff",
              color: darkMode ? "#e2e8f0" : "#475569"
            }}
          >
            <p style={{ margin: 0, fontSize: "16px", lineHeight: "1.6" }}>
              Are you sure you want to delete your account? This action is <strong>permanent</strong> and cannot be undone.
              All your data will be lost forever.
            </p>
          </ModalBody>
          <ModalFooter
            style={{
              background: darkMode ? "#1e293b" : "#ffffff",
              borderTop: darkMode ? "1px solid rgba(148, 163, 184, 0.1)" : "1px solid #e2e8f0",
              gap: "12px"
            }}
          >
            <Button
              color="secondary"
              onClick={() => setShowDeleteModal(false)}
              style={{
                background: darkMode ? "rgba(51, 65, 85, 0.8)" : "#f1f5f9",
                color: darkMode ? "#e2e8f0" : "#475569",
                border: "none",
                borderRadius: "8px",
                padding: "10px 20px",
                fontWeight: 500
              }}
            >
              Cancel
            </Button>
            <Button
              color="danger"
              onClick={handleDeleteAccount}
              style={{
                background: "#ef4444",
                border: "none",
                borderRadius: "8px",
                padding: "10px 20px",
                fontWeight: 500
              }}
            >
              Yes, Delete My Account
            </Button>
          </ModalFooter>
        </Modal>

      </Container>

      <style jsx>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        @keyframes soundWave1 {
          0%, 100% { height: 8px; opacity: 0.4; }
          50% { height: 16px; opacity: 1; }
        }
        
        @keyframes soundWave2 {
          0%, 100% { height: 12px; opacity: 0.4; }
          50% { height: 20px; opacity: 1; }
        }
        
        @keyframes soundWave3 {
          0%, 100% { height: 6px; opacity: 0.4; }
          50% { height: 14px; opacity: 1; }
        }
        
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
      `}</style>

    </ProfileLayout>
  );
};

export default Settings;